"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.filter.dateFrom': 'Data da',
    'dblogs.filter.dateTo': 'Data a',
    'dblogs.filter.models': 'Modelli',
    'dblogs.filter.models.placeholder': 'Tutti i modelli',
    'dblogs.filter.operations': 'Operazioni',
    'dblogs.filter.operations.placeholder': 'Tutte le operazioni',
    'dblogs.filter.recordIds': 'ID record',
    'dblogs.filter.recordIds.placeholder': 'Aggiungi valore con Invio',
    'dblogs.filter.search': 'Cerca',
};
